import { Provider } from './constants'
import * as cookie from './providers/cookie'
import * as memory from './providers/memory'
import * as webStorage from './providers/webStorage'

class Persist {
  static get cookie() {
    return {
      get: <T>(key: string, defaultValue: Nullable<T> = null): T | null => cookie.get(key, defaultValue),
      set: <T>(key: string, value: T): void => cookie.set(key, value),
      has: <T>(key: string): boolean => Boolean(cookie.get(key)),
      remove: (key: string): void => cookie.remove(key)
    }
  }

  static get memory() {
    return {
      get: <T>(key: string, defaultValue: Nullable<T> = null): T => memory.get(key, defaultValue),
      set: <T>(key: string, value: T): void => memory.set(key, value),
      has: <T>(key: string): boolean => Boolean(memory.get(key))
    }
  }

  static get localStorage() {
    return {
      get<T>(key: string, defaultValue: Nullable<T> = null): T {
        return webStorage.get(Provider.LOCAL_STORAGE, key, defaultValue)
      },
      set: <T>(key: string, value: T): void => webStorage.set(Provider.LOCAL_STORAGE, key, value),
      has: <T>(key: string): boolean => Boolean(webStorage.get(Provider.LOCAL_STORAGE, key))
    }
  }

  static get sessionStorage() {
    return {
      get<T>(key: string, defaultValue: Nullable<T> = null): T {
        return webStorage.get(Provider.SESSION_STORAGE, key, defaultValue)
      },
      set: <T>(key: string, value: T): void => webStorage.set(Provider.SESSION_STORAGE, key, value),
      has: <T>(key: string): boolean => Boolean(webStorage.get(Provider.SESSION_STORAGE, key))
    }
  }
}

export default Persist
